import React from "react";
import { View, StyleSheet } from "react-native";
import NtMarketingPageContainerHeader from "../../marketing/components/general/NtMarketingPageContainerHeader";
import NtImageBackground from "../../marketing/components/general/NtImageBackground";
import NtText from "../../components/NtText";
import NtSectionInputField from "../../marketing/components/general/NtSectionInputField";
import NtSectionButton from "../../marketing/components/general/NtSectionButton";
import { showToast, validateEmail } from "../../common/utils/ControllerUtils";
import { authenticateRequestCode } from "../../api/auth";
import Logger from "../../common/utils/Logger";
import BaseController from "../../common/base/BaseController";
import routes from "../../navigation/routes";

class AuthController extends BaseController {
  state = {
    loading: false,
    email: "",
  };

  handleLogin = async () => {
    this.setState({ loading: true });
    const response = await authenticateRequestCode(this.state.email);

    Logger("Response from requesting a code", response);
    if (response.ok) {
      this.props.navigation.navigate(routes.authcode, {
        token: btoa(this.state.email),
      });
    } else {
      showToast("Oops...", "Unable to process request. Please try again later");
    }

    this.setState({ loading: false });
  };

  isRequired = () => {
    return this.state.email && validateEmail(this.state.email);
  };

  render() {
    return (
      <View style={styles.container}>
        <NtImageBackground
          containerStyle={{ height: "100%" }}
          image={require("../../assets/images/marketing/ff8be5d5b3ab6249a5739ba42b1b268c10d1acda.png")}
        />

        <View
          style={{
            flex: 1,
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <View style={{ minWidth: 400 }}>
            <NtText
              style={{
                textAlign: "center",
                fontSize: 28,
                fontWeight: "500",
                color: "white",
              }}
            >
              SIGN IN
            </NtText>
            <NtText
              style={{
                textAlign: "center",
                fontSize: 14,
                fontWeight: "500",
                marginTop: 8,
                color: "white",
              }}
            >
              Use your CONNECT ID to sign in.
            </NtText>

            <NtSectionInputField
              containerStyle={{ marginTop: 40 }}
              title={"Email"}
              placeholder={"Enter your email"}
              value={this.state.email}
              setValue={(text) => this.setState({ email: text })}
            />

            <NtSectionButton
              containerStyle={{
                paddingTop: 6,
                paddingBottom: 6,
                marginTop: 40,
              }}
              loading={this.state.loading}
              textStyle={{ fontSize: 13 }}
              title="Login"
              color={"white"}
              onPress={
                this.isRequired()
                  ? () => {
                      this.handleLogin();
                    }
                  : null
              }
            />
          </View>
        </View>

        <NtMarketingPageContainerHeader />
      </View>
    );
  }
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
});

export default AuthController;
